import { normalize } from 'normalizr';

import * as schemas from 'schemas';
import { callApi, pageToOffsetParams } from 'utils/api';

export function journalEmojisFetch() {
  return callApi('/more/journal/emojis')
    .then(json => json.map(emoji => emoji.emoji));
}

export function journalEntriesFetch(page) {
  return callApi('/more/journal', {
    query: {
      ...pageToOffsetParams(page, process.env.KOOTH_PAGE_SIZE)
    }
  })
    .then(json => {
      const { journals, meta }  = json;
      const { result, entities } = normalize(journals, schemas.journalEntriesArraySchema);
      return {journalEntriesIds: result, entities, meta};
    });
}

export function journalEntryCreate(emoji, text) {
  return callApi('/more/journal', {
    method: 'POST',
    body: {
      emoji,
      text
    }
  });
}




/** WEBPACK FOOTER **
 ** ./src/members/state/journal/api.js
 **/